"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (function (virtual) { return function () { return ({
    action: 'devLogin',
    msgId: virtual.msgId,
    params: {
        devTid: virtual.device.devTid,
        prodKey: virtual.device.prodKey,
        token: virtual.device.token
    }
}); }; });



// WEBPACK FOOTER //
// ./src/actions/send/actions/devLogin.ts